import { Component, EventEmitter, model, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '@app/components/button';
import { DialogComponent } from '@app/components/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ContractCompanyType,
  ContractPaymentType,
  EnterpriseTenantContract,
} from '@skyfit/core-data-library';
import moment from 'moment';
import { ContractFormComponent } from '../contract-form/contract-form.component';

const defaultValues = {
  start: moment.utc().toDate(),
  employeePopulation: 0,
  paymentType: ContractPaymentType.PAPM,
  paymentAmount: 0,
  companyType: ContractCompanyType['Non-Marketplace'],
} as EnterpriseTenantContract;

@Component({
  selector: 'app-contract-dialog',
  standalone: true,
  imports: [
    ContractFormComponent,
    ButtonComponent,
    DialogComponent,
    TranslatePipe,
  ],
  templateUrl: './contract-dialog.component.html',
  styleUrls: ['./contract-dialog.component.css'],
})
export class ContractDialogComponent implements OnInit {
  isOpen = model(false);
  @Output() save = new EventEmitter<EnterpriseTenantContract>();
  contract: EnterpriseTenantContract;

  ngOnInit(): void {
    this.contract = { ...defaultValues };
  }

  onNoClick(): void {
    this.isOpen.set(false);
  }

  onSave(): void {
    this.save.emit(this.contract);
    this.onNoClick();
  }
}
